import { Injectable } from '@angular/core';

export enum Roles {
    ADMIN = 'ADMIN',
    ADMIN_USER_A = 'ADMIN_USER_A',
    ADMIN_USER_B = 'ADMIN_USER_B',
    COMPANY = 'COMPANY',
    COMPANY_USER_A = 'COMPANY_USER_A',
    SUBCONTRACTOR = 'SUBCONTRACTOR',
    SUBCONTRACTOR_SITE_MANAGER = 'SUBCONTRACTOR_SITE_MANAGER',
};

@Injectable({
    providedIn: 'root'
})
export class RolesService {

    public roles = Roles;

    constructor() { }

    public checkRoles(role: Roles, requiredRoles: Roles[]): boolean {
        if (!requiredRoles || requiredRoles.includes(role)) {
            return true;
        }
        return false;
    }

}